import { Select, FormControl, InputLabel, MenuItem } from '@mui/material';
import { useGetList, useRedirect } from 'react-admin';
import { useState, useEffect } from 'react';
import { getSelectedCompanyFilterValue } from '../helper/filter';
import { useLocalStorage } from '@uidotdev/usehooks';

export const CompanySwitch = () => {
  const redirect = useRedirect();
  const [themeName, saveThemeName] = useLocalStorage('themeName', null);
  const [selectedCompany, setSelectedCompany] = useState(
    getSelectedCompanyFilterValue()
  );

  const { data, isPending } = useGetList('companies', {
    pagination: { page: 1, perPage: 10 },
  });

  const handleChange = (e) => {
    setSelectedCompany(e.target.value);
    localStorage.setItem(
      'selectedCompany',
      JSON.stringify({ company: e.target.value })
    );
    redirect('/');
  };

  useEffect(() => {
    if (!data || data.length === 0) {
      return;
    }

    const selectedCompanyData = data.find(
      (item) => item['@id'] === selectedCompany
    );

    if (!selectedCompanyData) {
      const firstCompany = data[0];
      setSelectedCompany(firstCompany['@id']);
      localStorage.setItem(
        'selectedCompany',
        JSON.stringify({ company: firstCompany['@id'] })
      );
      redirect('/');
      return;
    }

    saveThemeName(selectedCompanyData.name.toLowerCase());
    window.dispatchEvent(new Event('storage'));
  }, [data, isPending, selectedCompany]);

  if (!isPending && (!data || data.length === 0)) {
    return null;
  }

  return (
    <FormControl sx={{ mx: 2, mb: 2 }}>
      <InputLabel id="company-switch-label">Company</InputLabel>
      <Select
        labelId="company-switch-label"
        id="company-switch"
        value={data?.some((item) => item['@id'] === selectedCompany) ? selectedCompany : ''}
        label="Company"
        onChange={handleChange}
        disabled={isPending}
        sx={{ width: '232px' }}
      >
        {data &&
          data.map((item) => (
            <MenuItem
              key={item['@id']}
              value={item['@id']}
              sx={{ width: '232px' }}
            >
              {item.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
